import * as React from 'react';
import Icon from 'components/Icon';
import VideoPlaceholder from 'components/VideoPlaceholder';
import { classNames } from 'utils/ui/css';

type TParticipantVideoProps = React.HTMLAttributes<HTMLDivElement> & {
  audioMuted: boolean;
  videoMuted: boolean;
  children: React.ReactNode;
  // allow additional class names to define who's on video
  className?: string;
};

const ParticipantVideo: React.FC<TParticipantVideoProps> = ({
  audioMuted = false,
  videoMuted = false,
  children,
  className,
  ...rest
}) => {
  return (
    <div {...rest} className={classNames('ex3d-participant-video', className)} part="participant-video">
      {audioMuted ? (
        <div className="ex3d-icon-wrapper--mic-off">
          <Icon className="ex3d-icon--mic-off" />
        </div>
      ) : null}
      {videoMuted && <VideoPlaceholder />}
      {/* Always keep children mounted so the <video> element's srcObject stays
          connected to the browser audio pipeline even when video is muted.
          The wrapper is collapsed to zero size to stay visually invisible. */}
      <div
        className={videoMuted ? 'absolute size-0 overflow-hidden' : 'size-full'}
        aria-hidden={videoMuted ? true : undefined}
      >
        {children}
      </div>
    </div>
  );
};

export default ParticipantVideo;
